<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Countries Table</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            data-toggle="tooltip"
                            data-widget="collapse"
                            title="Collapse"
                            type="button"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body table-responsive no-padding">
                    <div class="box-header with-border">
                        <select
                            v-model="selectedProviderId"
                            :disabled="loading"
                            class="form-control"
                            @change="getCosts"
                        >
                            <option
                                v-for="(provider, idx) in providers"
                                :key="idx"
                                :value="provider.id"
                            >
                                {{ provider.name }}
                            </option>
                        </select>
                    </div>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Code</th>
                                <th>Price</th>
                                <th class="text-right">Created at</th>
                                <th class="text-right">Updated at</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!costs.length && noCostsFound">
                                <td
                                    class="text-center"
                                    colspan="6"
                                >
                                    No Data found.
                                </td>
                            </tr>
                            <tr v-if="loading">
                                <td
                                    class="text-center"
                                    colspan="6"
                                >
                                    <img
                                        alt="Preloader"
                                        class="table-row-preloader"
                                        rel="preload"
                                        src="/img/table-row-preloader.gif"
                                    />
                                </td>
                            </tr>
                            <tr
                                v-for="(cost, i) in costs"
                                :key="i"
                            >
                                <td>{{ cost.country_id }}</td>
                                <td>{{ countries[cost.country_id]['name'] }}</td>
                                <td>{{ countries[cost.country_id]['code'] }}</td>
                                <td>${{ number_format(cost.price, 4, '.', ' ') }}</td>
                                <td class="text-right">{{ cost.created_at }}</td>
                                <td class="text-right">{{ cost.updated_at }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- /.box -->
        </div>
    </div>
</template>

<script>
import EventBus from '../../../event-bus';

export default {
    props: {
        countries: {
            type: Object,
            default: () => ({}),
        },
        providers: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            loading: false,
            noCostsFound: false,
            selectedProviderId: _.find(this.providers).id,
            costs: [],
        };
    },
    mounted: function () {
        this.getCosts();
    },
    methods: {
        getCosts: function () {
            const app = this;

            app.costs = [];
            app.loading = true;
            app.noCostsFound = false;

            EventBus.$emit('alertOptions', {
                displayAlert: false,
            });

            axios
                .get('/apis/providers/costs/provider-data/' + app.selectedProviderId)
                .then(function (resp) {
                    if (resp.data.success) {
                        app.costs = resp.data.costs;
                    } else {
                        EventBus.$emit('alertData', {
                            id: 1,
                            class: 'alert-danger',
                            message: resp.data && resp.data.message ? resp.data.message : 'Error',
                        });
                    }

                    if (!app.costs.length) app.noCostsFound = true;
                })
                .catch(function (resp) {
                    const data = resp.response && resp.response.data ? resp.response.data : null;

                    EventBus.$emit('alertData', {
                        id: 1,
                        class: 'alert-danger',
                        message: data.message || resp.message || 'Error',
                    });

                    app.noCostsFound = true;
                })
                .finally(function () {
                    app.loading = false;
                });
        },
    },
};
</script>
